var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"v-swap",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('swap')}}},[_c('img',{attrs:{"src":"/assets/img/exchange.svg","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }